module.exports = __webpack_public_path__ + "img/Diners.8f1a91de.svg";